
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ever5pfrvideYgtwJd_45piXgKtxst2bxvK6XCQvp_45vHLlTxQMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue?macro=true";
import { default as indexMpqOdWaqm9V6TGTM7sHnYtPcujaAqrsy6qvlG467i_wMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue?macro=true";
import { default as privacyev4VURc6xjVyA33XbS46YnuIV64t7oMSSg4E7Ri0RT0Meta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy.vue?macro=true";
import { default as _91_46_46_46slug_93r8WBra2r0yB3J0ds_dd7AfkVgKCv55iPptwrYaZqfZcMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue?macro=true";
import { default as _91id_93t4fvEt1uUkcVQ3Drp_sbt1q_45wHrJDRNujJCYS6pxa3MMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue?macro=true";
export default [
  {
    name: "ever",
    path: "/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  }
]